import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import {
  ColumnFilterConfig,
  ColumnFilterCriterion,
  TableFilterState,
  getActiveFilterCount,
  isCriterionActive,
} from '../table-filter.models';
import { ColumnFilterEditorComponent } from '../column-filter-editor/column-filter-editor.component';

export interface TableFiltersDialogData {
  configs: ColumnFilterConfig[];
  state: TableFilterState;
}

/** Edits a local filter snapshot and returns it when the user applies changes. */
@Component({
  selector: 'app-table-filters-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatExpansionModule,
    MatButtonModule,
    MatIconModule,
    ColumnFilterEditorComponent,
  ],
  templateUrl: './table-filters-dialog.component.html',
  styleUrls: ['./table-filters-dialog.component.scss'],
})
export class TableFiltersDialogComponent implements OnInit {
  localState: TableFilterState = {};
  panelExpanded: { [columnId: string]: boolean } = {};

  public dialogRef = inject<MatDialogRef<TableFiltersDialogComponent, TableFilterState>>(MatDialogRef);
  public data = inject<TableFiltersDialogData>(MAT_DIALOG_DATA);

  ngOnInit(): void {
    this.localState = { ...(this.data.state || {}) };
    for (const config of this.data.configs || []) {
      this.panelExpanded[config.columnId] = this.isColumnActive(config.columnId);
    }
  }

  get activeFilterCount(): number {
    return getActiveFilterCount(this.localState);
  }

  isColumnActive(columnId: string): boolean {
    return isCriterionActive(this.localState[columnId]);
  }

  onColumnCriterionChange(columnId: string, criterion: ColumnFilterCriterion | undefined): void {
    if (criterion && isCriterionActive(criterion)) {
      this.localState = { ...this.localState, [columnId]: criterion };
    } else {
      const next = { ...this.localState };
      delete next[columnId];
      this.localState = next;
    }
  }

  clearAll(): void {
    this.localState = {};
  }

  apply(): void {
    this.dialogRef.close(this.localState);
  }
}
